export default __webpack_public_path__ + "static/media/image-7.ca8867b5.jpg";